export enum BatteryResultV3Ids {
	NOT_ENOUGH_INFORMATION = 'not_enough_information',
	BATTERY_REPLACEMENT_BASED_ON_ENTRY = 'battery_replacement_based_on_entry',
	BATTERY_REPLACEMENT_BELOW_80_CAPACITY = 'battery_replacement_below_80_capacity',
	BATTERY_REPLACEMENT_LIFE_RATING_SELECTED = 'battery_replacement_life_rating_selected',
	BATTERY_HEALTHY = 'battery_healthy',
}
